const { SHOW_NOTI_DROPDOWN, ADD_NEW_NOTI, UPDATE_NOTI, GET_NOTI_COUNT,

ADD_NOTI_ERROR, GET_NOTIS, RESET_NOTIS, REMOVE_NOTI_COUNT,
SET_END_OF_NOTIS } = require("../types");

const INITIAL_STATE = {
  showNotiDropdown: false,
  
  unseenNotisCount: 0,
  notisList: [],
  error: null,
  endOfNewNotis: false,
}; 


const notificationsReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch(type) {
    case SHOW_NOTI_DROPDOWN:
      return { 
        ...state,
        showNotiDropdown: !state.showNotiDropdown,
        unseenNotisCount: 0
      }
    case RESET_NOTIS:
      return {
        unseenNotisCount: 0,
        notisList: [],
        error: null,
        endOfNewNotis: false,
      }
    case GET_NOTIS:
      return {
        ...state,
        notisList: [...payload],  
        error: null,
        endOfNewNotis: false
      }
    case UPDATE_NOTI:
      let a = state.notisList.concat(payload)
      return {
        ...state,
        notisList: [...a],
        unseenNotisCount: 0,
        error: null,
      }
    case GET_NOTI_COUNT:
      return {
        ...state,
        unseenNotisCount: parseInt(payload), 
      }
    case REMOVE_NOTI_COUNT:
      return {
        ...state,
        unseenNotisCount: 0
      }
    case ADD_NEW_NOTI: 
      return {
        ...state,
        notisList: [payload, ...state.notisList],
        unseenNotisCount: state.unseenNotisCount + 1,
        error: null
      }
    case ADD_NOTI_ERROR:
      return {
        ...state,
        error: 'Error Loading Notis',
      }
    case SET_END_OF_NOTIS:
      return {
        ...state,
        endOfNewNotis: true,
      }
    default:
      return state; 
  }
}


export default notificationsReducer;